export const REFERRAL_STATUSES = [
    "pending",
    "accepted",
    "in_progress",
    "completed",
    "overdue",
    "cancelled",
];
export const REFERRAL_STATUS_LABELS_FA = {
    pending: "در انتظار پذیرش",
    accepted: "پذیرفته‌شده",
    in_progress: "در حال انجام",
    completed: "انجام‌شده",
    overdue: "دارای تأخیر",
    cancelled: "لغوشده",
};
export const REFERRAL_TYPES = [
    "initial_review",
    "hearing_prep",
    "full_handling",
    "consultation",
];
export const REFERRAL_TYPE_LABELS_FA = {
    initial_review: "بررسی اولیه",
    hearing_prep: "آماده‌سازی جلسه",
    full_handling: "پیگیری کامل",
    consultation: "مشاوره",
};
export const REFERRAL_PRIORITIES = ["low", "normal", "high", "urgent"];
export const REFERRAL_PRIORITY_LABELS_FA = {
    low: "کم",
    normal: "عادی",
    high: "بالا",
    urgent: "فوری",
};
/** Built-in task statuses required by the API / workflows. */
export const SYSTEM_TASK_STATUSES = [
    "open",
    "in_progress",
    "blocked",
    "done",
    "cancelled",
];
/** @deprecated Prefer SYSTEM_TASK_STATUSES — kept for existing imports. */
export const TASK_STATUSES = SYSTEM_TASK_STATUSES;
export const ACTIVE_SYSTEM_TASK_STATUSES = [
    "open",
    "in_progress",
    "blocked",
];
export const TERMINAL_SYSTEM_TASK_STATUSES = [
    "done",
    "cancelled",
];
export const TASK_STATUS_LABELS_FA = {
    open: "باز",
    in_progress: "در حال انجام",
    blocked: "مسدود",
    done: "انجام‌شده",
    cancelled: "لغوشده",
};
/** Short Persian help for board headers / empty states. */
export const TASK_STATUS_HELP_FA = {
    open: "کار هنوز شروع نشده یا در صف انجام است",
    in_progress: "در حال کار روی این وظیفه",
    blocked: "کار به‌خاطر مانع، وابستگی یا انتظار به شخص/عامل بیرونی متوقف شده — لغو نشده است",
    done: "کار تمام شده است",
    cancelled: "کار لغو شده و دیگر پیگیری نمی‌شود",
};
export function isSystemTaskStatus(status) {
    return SYSTEM_TASK_STATUSES.includes(status);
}
/** Whether a status counts as open work (overdue filters, actionable inbox). */
export function isActiveTaskStatus(status, mapsTo) {
    const effective = mapsTo ?? status;
    if (TERMINAL_SYSTEM_TASK_STATUSES.includes(effective)) {
        return false;
    }
    if (isSystemTaskStatus(effective)) {
        return ACTIVE_SYSTEM_TASK_STATUSES.includes(effective);
    }
    // Unknown custom without mapsTo → treat as active
    return true;
}
export const TASK_TYPES = ["hearing", "document", "deadline", "general", "ops"];
export const TASK_TYPE_LABELS_FA = {
    hearing: "وقت رسیدگی",
    document: "سند / مکاتبه",
    deadline: "مهلت",
    general: "عمومی",
    ops: "عملیاتی",
};
export const TASK_SOURCES = [
    "manual",
    "ops",
    "case_referral",
    "deadline",
    "system_pending_action",
    "system_alarm",
    "contract_approval",
    "contract_signature",
    "contract_obligation",
    "contract_access_request",
];
export const TASK_SOURCE_LABELS_FA = {
    manual: "دستی",
    ops: "پروژه / درخواست",
    case_referral: "ارجاع پرونده",
    deadline: "مهلت",
    system_pending_action: "وقت رسیدگی",
    system_alarm: "یادآوری",
    contract_approval: "تأیید قرارداد",
    contract_signature: "امضای قرارداد",
    contract_obligation: "تعهد قراردادی",
    contract_access_request: "درخواست دسترسی به سند",
};
/** Work assignment sources (request assign + case referral) — not deadline-derived. */
export const TASK_ASSIGNMENT_SOURCES = ["ops", "case_referral"];
